import {Backdrop, CircularProgress} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  back: {
    display: "flex",
    flexFlow: "column nowrap",
    zIndex: theme.zIndex.modal + 2,
    color: "#fff",
  },
  textBody: {
    textAlign: "center",
  },
  text: {
    color: "#fff",
  }
}));

const BackDrop = (props) => {
  const { open = false, message="" } = props;
  const classes = useStyles();
  return (
    <Backdrop className={classes.back} open={open}>
      <CircularProgress color="primary" />
      {
        message !== "" &&
        <div className={classes.textBody}>
        <p className={classes.text}>{message}</p>
        </div>

      }
    </Backdrop>
  );
};
export default BackDrop;
